// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Legacy redirect route for /items/{itemKey}/movement.
 * Redirects to /catalog/items/{itemKey}/movement.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/items/$itemKey/movement')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/catalog/items/$itemKey/movement',
      params: { itemKey: params.itemKey },
      search: true,
    });
  },
});
